The date range criteria used to determine which events will be replayed.
